import { render, staticRenderFns } from "./NisSurvey.vue?vue&type=template&id=398ca3d3&scoped=true"
import script from "./NisSurvey.vue?vue&type=script&lang=js"
export * from "./NisSurvey.vue?vue&type=script&lang=js"
import style0 from "./NisSurvey.vue?vue&type=style&index=0&id=398ca3d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398ca3d3",
  null
  
)

export default component.exports